import styled from "styled-components";

import FormInput from "core/FormInput2";

import { AuthButton, FooterText } from "../styles";

import { convertPxToRem } from "frontend/components/helpers";

export const CtaButton = styled(AuthButton).attrs({
    styleType: "cta",
    type: "submit"
})``;

export const FormInputStyled = styled(FormInput).attrs({ size: "lg" })``;

export const FooterTextStyled = styled(FooterText)`
    display: flex;
    flex-direction: column;
    gap: ${convertPxToRem(16)};
`;
